// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoProvider_custom-dropdown__THJpC","item":"InfoProvider_item__W0d5r"};